/* global BASE_URL, PUBLIC_URL, linkNovySubjekt, kopirovatEmailDoPoznamky, subjectAutocompleteMinLength */

var xhr;
var xhrTimer;
var xhrTimeout = 1000;

$(function () {

	$.widget( "custom.catcomplete", $.ui.autocomplete, {
		_create: function() {
		  this._super();
		  this.widget().menu( "option", "items", "> :not(.ui-autocomplete-category)" );
		},
		// jQuery UI při prázdném výsledku menu zavře a volbu noResultsText nezná.
		__response: function( content ) {
		  if ( (!content || !content.length) && this.options.noResultsText && !this.options.disabled && !this.cancelSearch ) {
			content = [{
			  label: this.options.noResultsText,
			  value: this.options.noResultsText,
			  _noResults: true
			}];
		  }
		  this._super( content );
		},
		_move: function( direction, event ) {
		  if ( !this.menu.element.find( ".ui-menu-item" ).length ) {
			return;
		  }
		  this._super( direction, event );
		},
		_renderMenu: function( ul, items ) {
		  if ( items.length === 1 && items[0]._noResults ) {
			$( "<li>" )
			  .addClass( "ui-autocomplete-category ui-autocomplete-no-results" )
			  .text( items[0].label )
			  .appendTo( ul );
			return;
		  }

		  let that = this,
			  currentCategory = "";
		  $.each( items, function( index, item ) {
			let li;
			if ( item.category !== currentCategory ) {
			  ul.append( "<li class='ui-autocomplete-category'>" + item.category_name + "</li>" );
			  currentCategory = item.category;
			}
			that._renderItemData( ul, item );
		  });
		},
		_renderItem: function(ul, item) {
			return $("<li>")
				.append("<div>" + item.value + "</div>")
				.appendTo(ul);
		}
	});

	$('#dialog-evidence').click(function (event) {
		dialog(this, 'Evidovat');
		return false;
	});

	$('#dialog-odmitnout').click(function (event) {
		dialog(this, 'Odmítnout zprávu');
		return false;
	});

	$('.advancedAutoCompleteEpodatelna').catcomplete({
		minLength: subjectAutocompleteMinLength,
		resolver: 'custom',
		resolverSettings: {
		  requestThrottling: 100, //Default 500
		},
		noResultsText: "Nebyl nalezen žádný subjekt",
		source: function( request, response ) {
		  if(xhr && xhr.readystate != 4){
			xhr.abort();
		  }
		  window.clearTimeout(xhrTimer);
		  xhrTimer = window.setTimeout(function(){
			  xhr = $.ajax( {
				url: BASE_URL + "subjekty/seznam-ajax",
				data: {
				  term: request.term,
				  counts: 0
				},
				success: function( data ) {
				  response( data.results );
				}
			  } );
		  },xhrTimeout);
		},
		focus: function(event, ui) {
			event.preventDefault();
		},
		select: function(event, ui) {
			event.preventDefault();
			$('.advancedAutoCompleteEpodatelna').val('');

			let item = ui.item;

			switch (item.type) {
				case 'subjekt':
					renderEpodSubjekty(item.id);
					break;

				case 'adresni_skupina':
					renderEpodAdresniSkupiny(item.id);
					break;
			}
			return false;
		}
	});


	$('#subjekt_novy').on('click', '#epod_evid_novysubjekt_click', function (event) {
		dialog(this, 'Nový subjekt');
		return false;
	});


});

evidNovySubjektOk = function (data) {
	alert('Subjekt byl úspěšně vytvořen.');
	// $('#dialog').dialog('close');
	$('#theModal').modal('hide');
	closeDialog();
	// renderEpodSubjekty(data.id_contact);
};

zpravyNovySubjektOk = function (data) {
	alert('Subjekt byl úspěšně vytvořen.');
	$('#dialog').dialog('close');
	var id = data.extra_data;
	var checkbox = '<input type="checkbox" name="subjekt[' + data.id_contact + ']" checked="checked" />';
	checkbox += data.name + '<br/>';
	$('#subjekt_seznam_' + id).append(checkbox);
};

renderEpodSubjekty = function (contact_id, check = true) {

	if ($('.subjectContactsRow.contacts'+contact_id).length != 0){
		renderEpodKontakt(contact_id);
	}
	else{
		var url = BASE_URL + 'epodatelna/subjekty/nacti?contactid=' + contact_id + '&check=' + (check ? 1 : 0);

		// odesílatel zprávy pro předvyplnění nového kontaktu (jen na evidenci zprávy z ePodatelny)
		var odesilatel = $('#dok-subjekty').attr('data-odesilatel');
		if (odesilatel) {
			url = url + '&odesilatel=' + encodeURIComponent(odesilatel);
		}

		$.get(url, function (subjekt) {
			var scripts = ($(subjekt).filter("script"));
			if ($('#subjekty-table').length == 0) {
				var html = '<table class="seznam seznam-bordered table table-hover" id="subjekty-table"><tbody>';
				html = html + subjekt;
				html = html + '</tbody></table>';
				$('#dok-subjekty').html(html);
			} else {
				var subjekt_tr = $('#subjekty-table #subjekt-' + contact_id);
				var id = $(subjekt).attr("id");
					var subjectId = $(subjekt).data("subject");
				if($('#subjekty-table #subjekt-'+subjectId).length != 0){
					$('#subjekty-table #subjekt-'+subjectId).replaceWith($(subjekt).filter('#subjekt-'+subjectId));
				}
				if($('#subjekty-table #subjekt-'+contact_id).length != 0){
					var removeLast = true;
					if($('#subjekty-table #subjekt-'+contact_id).hasClass("last")){
						removeLast = false;
					}
					$('#subjekty-table #subjekt-'+contact_id).replaceWith($(subjekt).filter('#subjekt-'+contact_id));
					$('#subjekty-table tbody').append(scripts);
					if(removeLast){
						$('#subjekty-table #subjekt-'+contact_id).removeClass("last");
					}
				}
				else if ($('.subjectContactsRow.contacts'+subjectId).length != 0){
						$('.subjectContactsRow.contacts'+subjectId+'.last').removeClass("last");

						// odznačení předešlých řádků
						$('#subjekty-table .contactCheck').prop('checked', false);

						$(subjekt).insertAfter($('.subjectContactsRow.contacts'+subjectId+':last'));
						$('.subjectResultsRow.subjectResults'+subjectId).each(function(index){
							if(index>0){
								$(this).remove();
							}
						});
					}
					else{
						// odznačení předešlých řádků
						$('#subjekty-table .contactCheck').prop('checked', false);
						// Nové řádky patří do stejného těla tabulky jako původní shody.
						$('#subjekty-table tbody').append(subjekt);
					}
				}
		});
	}

	return false;
};

renderEpodKontakt = function (contact_id) {

	var url = BASE_URL + 'epodatelna/subjekty/nacti-kontakt/' + contact_id;

	$.get(url, function (subjekt) {
		var scripts = ($(subjekt).filter("script"));
		var subjectId = $(subjekt).data("subject");
		var id = $(subjekt).attr("id");
		if($('#'+id).length != 0){
			$('.subjectContactsRow.contacts'+subjectId+':last').replaceWith(subjekt);
		}
		else if ($('.subjectContactsRow.contacts'+subjectId).length != 0){
			$('.subjectContactsRow.contacts'+subjectId+'.last').removeClass("last")
			$(subjekt).insertAfter($('.subjectContactsRow.contacts'+subjectId+':last'));
		}
		else{
			$('#subjekty-table tbody').append(scripts);
		}
	});

	return false;
};

renderEpodAdresniSkupiny = function(subjekt_id) {
	var url = BASE_URL + 'epodatelna/subjekty/nacti-adresni-skupinu/' + subjekt_id;

	$.get(url, function(subjekt) {
		var scripts = ($(subjekt).filter("script"));
		var rows = ($(subjekt).filter("tr"));
		if ($('#subjekty-table').length == 0) {
			var html = '<table class="seznam seznam-bordered table table-hover" id="subjekty-table"><tbody>';
			html = html + subjekt;
			html = html + '</tbody></table>';
			$('#dok-subjekty').html(html);
		} else {
			//iterujeme řádky a vkládáme je pouze pokud ve výsledku již neexistují
			rows.each(function(index){
				var row = $(this);
				var subjectId = row.data("subject");
				var added = [];
				if($("#"+row.attr("id")).length==0){
					if(row.hasClass("subjectResultsRow") && !added[subjectId]){
						//jedná se o subjekt
						$('#subjekty-table tbody').append(row);
						added[subjectId];
					}
					if(row.hasClass("subjectContactsRow")){
						//jedná se o kontakt
						if ($('.subjectContactsRow.contacts'+subjectId).length != 0){
							$('.subjectContactsRow.contacts'+subjectId+'.last').removeClass("last")
							$(row).insertAfter($('.subjectContactsRow.contacts'+subjectId+':last'));
						}
						else{
							$(row).insertAfter('#subjekty-table .subjectResultsRow.subjectResults'+subjectId);
						}
					}
				}
			});
			$('#subjekty-table tbody').append(scripts);
		}
	});

	return false;
};

epodSubjektVybran = function (contact_id) {

	$('#dialog').dialog('close');
	closeDialog();
	renderEpodSubjekty(contact_id);
};

function pridejAdresniSkupinuKEpodatelne(skupina_id) {
  var url = BASE_URL + "epodatelna/subjekty/vratkontaktyadresniskupiny/?skupina_id=" + skupina_id;

  $.get(url, function (kontakty) {
	kontakty.forEach(function (id) {
		renderEpodSubjekty(id);
	})
  });

  return false;
}

passwordPrompt = function () {
	var dialog = $('#password_prompt').dialog({
		height: 150,
		width: 230,
		modal: true,
		closeOnEscape: false,
		buttons: {
			Ok: function () {
				var password = $('input[type=password]').val();
				dialog.dialog("close");
				passwordCallback(password);
			}
		}
	});
};

zkontrolovatSchranku = function (nacist_nove_zpravy, password) {

	// pro jistotu. Ošetři případ, že by byl parametr neuveden.
	if (typeof nacist_nove_zpravy === 'undefined')
		nacist_nove_zpravy = true;

	var postdata = {};
	if (password) {
		// alert('Heslo je ' + password);
		postdata = {password: password};
	}

	$('#zkontrolovat_prubeh_info').html('<img src="' + PUBLIC_URL + 'images/spinner-grey.svg" width="22" height="22" /> Kontroluji schránky ...<br /><br />');
	prubeh = setInterval(pruhebNacitani, 1000);

	var url = BASE_URL + 'epodatelna/default/zkontrolovat-ajax';

	$.post(url, $.param(postdata), function (data) {
		/*$('#zkontrolovat_prubeh_info').html('');
		 $('#zkontrolovat_prubeh').html(data);*/
		$('#zkontrolovat_prubeh_info').html(data + '<br />');
		$('#zkontrolovat_prubeh_detail').html('');
		clearInterval(prubeh);
		// nacteni novych zprav z database se musi provest az po stazeni vsech zprav z e-mailove schranky
		if (nacist_nove_zpravy) {
			window.setTimeout(function(){
				window.location.href = BASE_URL + 'epodatelna/default/nove';
			}, 5000);
			//nactiZpravy();
		} else {
			$('#zkontrolovat_prubeh').append('<br /><input type="button" value="Načíst nové zprávy"\n\
				onclick="' + "nactiZpravy(); $('#zkontrolovat_prubeh').hide()" + '" />');
		}
	}).fail(function (data) {
		$('#zkontrolovat_prubeh').html('Při kontrole zpráv došlo k chybě.');
	});
};

function pruhebNacitani(){
	$.get( BASE_URL + "epodatelna/default/zkontrolovat-prubeh-ajax", { password: "", ids: "2pm" }, function( data ) {
		if (data['typ'] === 'email'){
			if (data['stav'] === 'hlavicky'){
				$('#zkontrolovat_prubeh_detail').html('Kontrola emailové schránky ' + data['schranka'] + ' - načtení hlaviček zpráv');
			} else {
				$('#zkontrolovat_prubeh_detail').html('Kontrola emailové schránky ' + data['schranka'] + ' ' + data['stav'] + ' ' + data['pocet'] +' / ' + data['celkem']);
			}
		} else if (data['typ'] === 'zpravy'){
			if (data['stav'] === 'hlavicky'){
				$('#zkontrolovat_prubeh_detail').html('Načtení nových zpráv');
			} else if (data['celkem'] !== data['pocet']) {
				$('#zkontrolovat_prubeh_detail').html('Načtení zobrazení nových zpráv ' + data['pocet'] +' / ' + data['celkem']);
			}
		} else {
			$('#zkontrolovat_prubeh_detail').html('Kontrola datové schránky');
		}
	});
}

function validate(user) {

	var text2 = "Není vyplněné pole předat.\n";
	var text3 = "Chcete pokračovat?";
	var textMessage = '';


	if (user==='' || user === undefined) {
		textMessage = textMessage+text2;
	}

	if (textMessage === '') {
		return true;
	}

	textMessage = textMessage+text3;

	var result = confirm(textMessage);
	return !!result;

}

nactiZpravy = function () {

	var attachHandlers = function () {

		var loadAttachments = function () {
			var anchor = $(this);
			$.getJSON(this.href, function (attachments) {
				var id = anchor.attr('id');
				id = id.substring(3);
				var url = BASE_URL + 'epodatelna/prilohy/download/' + id + '?file=';
				var a = attachments;
				var s = '';

				if (attachments !== null) {
					for (var i = 0; i < a.length; i++) {
						s = s + '<li><input type="checkbox" name="prilohyPost[]" value="' + a[i].name + '" checked> <a href="' + url + a[i].id + '&name=' + a[i].name + '">' + a[i].name + '</a>  (' + bytesToSize(a[i].size) + ')</li>';
					}
				}
				anchor.replaceWith(s);
			});
			return false;
		};

		var submitHandler = function () {

			var id = $(this).data('id');
			var formdata = 'id=' + id + '&' + $('#form' + id).serialize();

			var validateForward = document.getElementById('validateForward').value;
			if (validateForward === '1') {
				var user = document.getElementById('predat_'+id).value;
				var res = validate(user);
				if (res === false) {
					return false;
				}
			}
			$.post($('#h_evidence').data('action'), formdata, function (text) {
				if (text[0] === "#") {
					text = text.substr(3);
					alert(text);
				} else {
					text = '<div class="evidence_report">' + text + '</div>';
					$('#evidence_show_' + id).html(text);
				}
			});

			return false;
		};

		var formSwitcher = function () {

			var id = $(this).parent().data('id');
			var value = $(this).val();

			$('#evidence_form_evidovat_' + id).hide();
			$('#evidence_form_jina_evidence_' + id).hide();
			$('#evidence_form_odmitnout_' + id).hide();

			if (value == 0) {
			} else if (value == 1) {
				$('#evidence_form_evidovat_' + id).show();
			} else if (value == 2) {
				$('#evidence_form_jina_evidence_' + id).show();
			} else if (value == 3) {
				$('#evidence_form_odmitnout_' + id).show();
			}
		};

		$('a.load-attachments').click(loadAttachments);

		$('input[type=submit]').click(submitHandler);

		$("input[name^=volba_evidence]").click(formSwitcher);

		$('.evidence_zprava_toggler').click(function () {
			var id = $(this).data('id');
			$('#evidence_zprava_' + id).toggle();
		});

		$('input[name=subjekt_autocomplete]').catcomplete({
			minLength: subjectAutocompleteMinLength,
			resolver: 'custom',
			resolverSettings: {
			  requestThrottling: 100, //Default 500
			},
			noResultsText: 'Nebyl nalezen žádný subjekt',
			source: function( request, response ) {
			  if(xhr && xhr.readystate != 4){
				xhr.abort();
			  }
			  window.clearTimeout(xhrTimer);
			  xhrTimer = window.setTimeout(function(){
				  xhr = $.ajax( {
					url: BASE_URL + "subjekty/seznam-ajax",
					data: {
					  term: request.term
					},
					success: function( data ) {
					  response( data.results );
					}
				  } );
			  },xhrTimeout);
			},
			select: function(event, ui) {
				event.preventDefault();
				$('input[name=subjekt_autocomplete]').val('');
				let item = ui.item;
				var subjekt_seznam = '<input type="checkbox" name="subjekt[' + item.id + ']" /> ';
				subjekt_seznam = subjekt_seznam + item.value + '<br/>';
				$('#subjekt_seznam_' + $(this).data('id')).append(subjekt_seznam);

				return false;
			}
		});

		$('input[name=user_autocomplete]').autoComplete({
			minLength: 3,
			resolver: 'custom',
			noResultsText: 'Nebyl nalezen žádný uživatel',
			formatResult: function (item) {
				return {
					value: item.id,
					text: item.value,
				};
			},
			events: {
				search: function (qry, callback) {
					$.ajax(
						BASE_URL + 'uzivatel/user-seznam-ajax',
						{
							data: { 'term': qry}
						}
					).done(function (res) {
						callback(res.results);
					});
				}
			}
		});

		$('input[name=user_autocomplete]').on('autocomplete.select', function (evt, item) {

			$('input[name=user_autocomplete]').val('');
			var notifikace_seznam = '<input type="checkbox" name="user[' + item.id + ']" /> ';
			notifikace_seznam = notifikace_seznam + item.value + '<br/>';
			$('#notifikace_seznam_' + $(this).data('id')).append(notifikace_seznam);

			return false;
		});

		$('input[name=subjekt_dotceny_autocomplete]').catcomplete({
			minLength: subjectAutocompleteMinLength,
			resolver: 'custom',
			resolverSettings: {
			  requestThrottling: 100, //Default 500
			},
			noResultsText: 'Nebyl nalezen žádný subjekt',
			source: function( request, response ) {
			  if(xhr && xhr.readystate != 4){
				xhr.abort();
			  }
			  window.clearTimeout(xhrTimer);
			  xhrTimer = window.setTimeout(function(){
				  xhr = $.ajax( {
					url: BASE_URL + "subjekty/seznam-ajax",
					data: {
					  term: request.term
					},
					success: function( data ) {
					  response( data.results );
					}
				  } );
			  },xhrTimeout);
			},
			select: function(event, ui) {
				let item = ui.item;
				$('input[name=subjekt_dotceny_autocomplete]').val('');
				var subjekt_dotceny_seznam = '<input type="checkbox" name="subjektDotceny[' + item.id + ']" checked /> ';
				subjekt_dotceny_seznam = subjekt_dotceny_seznam + item.value + '<br/>';
				$('#subjekt_dotceny_seznam_' + $(this).data('id')).append(subjekt_dotceny_seznam);

				return false;
			}
		});
	};

	prubeh = setInterval(pruhebNacitani, 1000);
	var url = BASE_URL + 'epodatelna/default/nacti-nove-ajax';
	$.getJSON(url, function (zpravy) {
		$('#zkontrolovat_prubeh_detail').html('Vykreslování zpráv...');
		if (zpravy != '') {
			var len = zpravy.length;
			for (var i = 0; i < len; i++) {
				generujZpravu(zpravy[i]);
			}
			attachHandlers();
		}
		$('#zkontrolovat_prubeh_detail').html('');
		clearInterval(prubeh);
	});
};

bytesToSize = function (bytes) {
	var sizes = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	if (bytes == 0)
		return 'n/a';
	var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
	var s = (bytes / Math.pow(1024, i)).toFixed(i > 1 ? 1 : 0);
	return s.replace('.', ',') + ' ' + sizes[i];
};


generujZpravu = function (data) {

	var id = data.id;
	var typ = 0;
	var typ_string, form_odmitnout;

	if (data['typ'] == "E") {
		typ = 1;
		typ_string = '<i class="fa-solid fa-at float-left" alt="přijat e-mailem" title="přijat e-mailem"></i>';

		form_odmitnout = '                    <dl>' +
				'                        <dt></dt>' +
				'                        <dd><input type="checkbox" name="odmitnout" /> Poslat upozornění odesilateli?</dd>' +
				'                    </dl>' +
				'                    <dl>' +
				'                        <dt>E-mail odesílatele:</dt>' +
				'                        <dd><input type="text" name="zprava_email" value="' + data['odesilatel'] + '" class="form-control"/></dd>' +
				'                    </dl>' +
				'                    <dl>' +
				'                        <dt>Předmět pro odesílatele:</dt>' +
				'                        <dd><input type="text" name="zprava_predmet" value="RE: ' + data['predmet'] + '" class="form-control" /></dd>' +
				'                    </dl>' +
				'                    <dl>' +
				'                        <dt>Zpráva pro odesilatele:</dt>' +
				'                        <dd><textarea name="zprava_odmitnuti" rows="3" cols="60" class="form-control"></textarea></dd>' +
				'                    </dl>';

	} else if (data['typ'] == "I") {
		typ = 2;
		typ_string = '<i class="fa-solid fa-archive float-left text-warning" alt="přijat datovou schránkou" title="přijat datovou schránkou"></i>';
		form_odmitnout = '';
	} else {
		typ_string = '';
		form_odmitnout = '';
	}

	var prilohy = '';
	if (data['prilohy'].length > 0) {
		for (var key in data['prilohy']) {
			prilohy = prilohy + '                    <li><input type="checkbox" name="prilohyPost[]" value="' + data['prilohy'][key]['name'] + '" checked><a href="' + BASE_URL + 'epodatelna/prilohy/download/' + id + '?file=' + data['prilohy'][key]['id'] + '">' + data['prilohy'][key]['name'] + ' <i class="fa-solid fa-download"></i></a> [ ' + bytesToSize(data['prilohy'][key]['size']) + ' ]</li>';
		}
	} else {
		var url = BASE_URL + 'epodatelna/prilohy/attachments/' + id;
		prilohy = '<a href="' + url + '" class="load-attachments" id="la-' + id + '">Načíst</a>';
	}

	var subjekt_seznam = '';
	var subjekt_dotceny_seznam = '';
	if (typeof data['subjekt']['databaze'] != 'null') {
		var first = true;
		var checked = ' checked ';
		for (var key in data['subjekt']['databaze']) {

			subjekt_seznam = subjekt_seznam + '<input type="checkbox" ' + checked  + 'name="subjekt[' + data['subjekt']['databaze'][key]['id'] + ']" />';
			subjekt_seznam = subjekt_seznam + data['subjekt']['databaze'][key]['full_name'] + '<br/>';
			if (first) {
				first = false;
				checked = " "
			}
		}
	}

	var notifikace_seznam = '';

	var meta = JSON.parse(data.hlavicka_DZ);

	var subject_new = '';

	if (data['access'] === true) {
		subject_new = '<dl id="subjekt_novy_' + id + '">' +
			'           <dt></dt>' +
			'          	<dd><a href="' + linkNovySubjekt + '" id="novysubjekt_click_' + id + '">Vytvořit nový subjekt z odesílatele</a></dd>' +
			'          </dl>';
	}


	var zprava = '<form id="form' + id + '">' +
			'   <div class="evidence_item"> ' +
			'       <div class="evidence_item_header">' +
			'           ' + typ_string +
			'           <div class="evidence_item_cas">' +
			'               ' + data['doruceno_dne_datum'] + '<br/>' + data['doruceno_dne_cas'] + '' +
			'           </div>' +
			'           <div class="evidence_info">' +
			'               <span class="nazev">' + data['predmet'] + '</span>' +
			'               ' + data['odesilatel'] + '' +
			'           </div>' +
			'           <br class="clear" />' +
			'       </div>' +
			'       <div class="evidence_item_proccess" id="evidence_show_' + id + '">' +
			'           <div class="evidence_volba" data-id="' + id + '">' +
			'                Volba evidence:<br />' +
			'                <input type="radio" name="volba_evidence" value="0" title="Tato zpráva zůstane nezpracována. Bude zpracována později." /> Nedělat nic<br/>' +
			'                <input type="radio" name="volba_evidence" value="1" title="Zaeviduje zprávu do spisové služby."/> Evidovat<br/>' +
			'                <input type="radio" name="volba_evidence" value="2" title="Zaeviduje zprávu do jiné evidence. Nebude součásti spisové služby."/> Evidovat do jiné evidence<br/>' +
			'                <input type="radio" name="volba_evidence" value="3" title="Zpráva bude odmítnuta."/> Odmítnout<br/>' +
			'            </div>' +
			'            <div class="evidence_form">' +
			'                <div class="evidence_zprava_toggler" data-id="' + id + '">Zobrazit zprávu >></div>' +
			'                <div class="evidence_zprava" id="evidence_zprava_' + id + '">' +
			data['popis'] +
			'                </div>' +
			'                <span>Přílohy:</span>' +
			'                <ul id="evidence_prilohy_' + id + '">' +
			prilohy +
			'                </ul>' +
			'                <div id="evidence_form_evidovat_' + id + '">' +
			'                    <span>Subjekt:</span>' +
			'                    <dl>' +
			'                        <dt>Nalezené subjekty:</dt>' +
			'                        <dd id="subjekt_seznam_' + id + '">' +
			subjekt_seznam +
			'                        </dd>' +
			'                    </dl>' +
			'                    <dl>' +
			'                        <dt>Hledat subjekt:</dt>' +
			'                        <dd class="ui-widget">' +
			'                           <input type="text" name="subjekt_autocomplete" data-id="' + id + '" size="60" class="form-control" />' +
			'                        </dd>' +
			'                    </dl>' +
			subject_new +

			'                    <span>Notifikace:</span>' +
			'                    <dl>' +
			'                        <dt>Uživatelé:</dt>' +
			'                        <dd id="notifikace_seznam_' + id + '">' +
										notifikace_seznam +
			'                        </dd>' +
			'                    </dl>' +
			'                    <dl>' +
			'                        <dt>Hledat uživatele:</dt>' +
			'                        <dd class="ui-widget">' +
			'                           <input type="text" name="user_autocomplete" data-id="' + id + '" autocomplete="off" size="60" class="form-control" />' +
			'                        </dd>' +
			'                    </dl>' +



								'<span>Související subjekt:</span>' +
			'                    <dl>' +
			'                        <dt>Subjekt:</dt>' +
			'                        <dd id="subjekt_dotceny_seznam_' + id + '">' + subjekt_dotceny_seznam + '</dd>' +
			'                    </dl>' +
								'<dl>' +
									'<dt>Hledat subjekt:</dt>' +
									'<dd class="ui-widget">' +
										'<input type="text" autocomplete="off" name="subjekt_dotceny_autocomplete" data-id="' + id + '" size="60" class="form-control" />' +
									'</dd>' +
								'</dl>' +
			// '                   <dl id="subjekt_novy_' + id + '">' +
			// '                   	<dt></dt>' +
			// '                       <dd><a href="' + linkNovySubjekt + '" id="novysubjekt_click_' + id + '">Vytvořit nový subjekt z odesílatele</a></dd>' +
			// '                   </dl>' +

			'                    <span>Zaevidovat do spisové služby.</span>' +
			'                    <dl>' +
			'                        <dt>Věc:</dt>' +
			'                        <dd><input type="text" name="nazev" value="' + data['predmet'] + '" size="60" class="form-control" /></dd>' +
			'                    </dl>' +
			'                    <dl>' +
			'                        <dt>Popis:</dt>' +
			'                        <dd><textarea name="popis" rows="3" class="form-control"></textarea></dd>' +
			'                    </dl>' +
			'                    <dl>' +
			'                        <dt>Poznámka:</dt>' +
			'                        <dd><textarea name="poznamka" rows="5" class="form-control">' + '</textarea></dd>' +
			'                    </dl>' +
			'                    <dl>' +
			'                        <dt>Předat:</dt>' +
			'                        <dd class="ui-widget">' +
			'                           <input type="text" autocomplete="off" name="predat_autocomplete" id="predat_autocomplete_' + id + '" size="60" class="form-control" />' +
			'                           <input type="hidden" name="predat" id="predat_' + id + '" />' +
			'                        </dd>' +
			'                    </dl>' +
			'                    <dl>' +
			'                        <dt>Poznámka k předání:</dt>' +
			'                        <dd><textarea name="predani_poznamka" rows="3" class="form-control"></textarea></dd>' +
			'                    </dl>' +
			'                    <dl>' +
			'                        <dt></dt>' +
			'                        <dd><input type="hidden" name="cislo_jednaci_odesilatele" value="' + (typeof (meta.dmSenderRefNumber) === 'undefined' || meta.dmSenderRefNumber === null ? "" : meta.dmSenderRefNumber) + '"/>' +
			'                            <input type="submit" name="evidovat" id="evidovat_'+ id +'" value="Zaevidovat tuto zprávu" data-id="' + id + '" class="btn btn-danger btn-sm" /></dd>' +
			'                    </dl>' +
			'                </div>' +
			'                <div id="evidence_form_jina_evidence_' + id + '">' +
			'                    <span>Zaevidovat zprávu do jiné evidence.</span>' +
			'                    <dl>' +
			'                        <dt>Evidence:</dt>' +
			'                        <dd><textarea name="evidence" rows="3" class="form-control"></textarea></dd>' +
			'                    </dl>' +
			'                    <dl>' +
			'                        <dt></dt>' +
			'                        <dd><input type="submit" name="evidovat_jinam" value="Zaevidovat tuto zprávu do jiné evidence" data-id="' + id + '" class="btn btn-danger btn-sm"/></dd>' +
			'                    </dl>' +
			'                </div>' +
			'                <div id="evidence_form_odmitnout_' + id + '">' +
			'                    <span>Odmítnout zprávu.</span>' +
			'                    <dl>' +
			'                        <dt>Důvod odmítnutí:</dt>' +
			'                        <dd><textarea name="duvod_odmitnuti" rows="3" cols="60" class="form-control"></textarea></dd>' +
			'                    </dl>' +
			form_odmitnout +
			'                    <dl>' +
			'                        <dt></dt>' +
			'                        <dd>' +
			'                           <input type="hidden" name="odmitnout_typ" value="' + typ + '" />' +
			'                           <input type="submit" name="odmitnout" value="Odmítnout tuto zprávu" data-id="' + id + '" class="btn btn-danger btn-sm" />' +
			'                        </dd>' +
			'                    </dl>' +
			'                </div>' +
			'            </div>' +
			'            <br class="clear" />' +
			'        </div>' +
			'        <br class="clear" />' +
			'    </div>' +
			'</form>';

	$('#h_evidence').append(zprava);
	if (data.typ === 'E' && kopirovatEmailDoPoznamky) {
		$('#evidence_form_evidovat_' + id + ' textarea[name="poznamka"]').html(data['popis']);
	}


	$('#predat_autocomplete_' + id).autoComplete({
		minLength: 3,
		resolver: 'custom',
		noResultsText: 'Nebyl nalezen žádný uživatel',
		formatResult: function (item) {
			return {
				value: item.id,
				text: item.value,
			};
		},
		events: {
			search: function (qry, callback) {
				$.ajax(
					BASE_URL + 'uzivatel/seznam-ajax',
					{
						data: { 'term': qry}
					}
				).done(function (res) {
					callback(res.results);
				});
			}
		}
	});

	$('#predat_autocomplete_' + id).on('autocomplete.select', function (evt, item) {
		$('#predat_' + id).val(item.id);
		return false;
	});




	// $.parseJSON(postdata);
	var postdata = JSON.stringify(data['subjekt']['original']);

	$('#novysubjekt_click_' + id).click(function (event) {
		dialog(this, 'Nový subjekt', $(this).attr('href') + '&extra_data=' + id);
		return false;
	}).attr('data-postdata', postdata);

	$('#evidence_form_evidovat_' + id).hide();
	$('#evidence_form_jina_evidence_' + id).hide();
	$('#evidence_form_odmitnout_' + id).hide();
	$('#evidence_zprava_' + id).hide();

};

/* Detail přílohy v right-sidebar */
(function () {
	const sidebarSelector = '#right-sidebar';
	const sidebarContentSelector = '#right-sidebar-content';
	const sidebarTitleSelector = '#right-sidebar-title';
	const animationDelay = 300;
	let previousEpodatelnaPrilohaKey = null;
	let epodatelnaSidebarOpen = false;

	function ensureSidebarApi() {
		if (typeof window.setRightSidebarContent !== 'function') {
			window.setRightSidebarContent = function (html) {
				$(sidebarContentSelector).html(html);
			};
		}
		if (typeof window.clearRightSidebarContent !== 'function') {
			window.clearRightSidebarContent = function () {
				$(sidebarContentSelector).html('');
			};
		}
		if (typeof window.setRightSidebarTitle !== 'function') {
			window.setRightSidebarTitle = function (title) {
				$(sidebarTitleSelector).text(title);
			};
		}
		if (typeof window.showRightSidebar !== 'function') {
			window.showRightSidebar = function () {
				const $el = $(sidebarSelector);
				if ($.ui && $.ui.effect) {
					$el.show('slide', {direction: 'right'}, animationDelay);
				} else {
					$el.css('display', 'flex').show();
				}
			};
		}
		if (typeof window.hideRightSidebar !== 'function') {
			window.hideRightSidebar = function () {
				const $el = $(sidebarSelector);
				if ($.ui && $.ui.effect) {
					$el.hide('slide', {direction: 'right'}, animationDelay);
				} else {
					$el.hide();
				}
			};
		}
	}

	$(document).on('click', '#right-sidebar-close', function () {
		epodatelnaSidebarOpen = false;
		previousEpodatelnaPrilohaKey = null;
	});

	$(document).on('click', '.epodatelna-priloha-toggle-sidebar-detail', function (e) {
		e.preventDefault();
		e.stopPropagation();
		ensureSidebarApi();

		const id = $(this).attr('data-id');
		const file = $(this).attr('data-file');
		const nameRaw = $(this).attr('data-name') || '';
		const name = encodeURIComponent(nameRaw);
		if (!id) {
			window.setRightSidebarContent('<div class="alert alert-danger">Chybí identifikátor zprávy.</div>');
			window.setRightSidebarTitle('Detail komponenty');
			window.showRightSidebar();
			return;
		}
		const key = id + '-' + file + '-' + name;
		// id musí být v cestě (routa epodatelna/<presenter>/<action>/<id>);
		// query id= je záloha pro starší cache JS / případy bez path parametru
		const url = BASE_URL + 'epodatelna/default/priloha-detail/' + encodeURIComponent(id)
			+ '?id=' + encodeURIComponent(id)
			+ '&file=' + encodeURIComponent(file == null ? '' : file)
			+ '&name=' + name;

		if (epodatelnaSidebarOpen && previousEpodatelnaPrilohaKey === key) {
			window.clearRightSidebarContent();
			window.hideRightSidebar();
			$('.attachment-line').removeClass('grid-row-selected');
			epodatelnaSidebarOpen = false;
			previousEpodatelnaPrilohaKey = null;
			return;
		}

		previousEpodatelnaPrilohaKey = key;
		$('.attachment-line').removeClass('grid-row-selected');
		$(this).closest('.attachment-line').addClass('grid-row-selected');

		if (epodatelnaSidebarOpen) {
			window.clearRightSidebarContent();
		}

		$.ajax({
			url: url,
			method: 'GET',
			headers: {'X-Requested-With': 'XMLHttpRequest'},
			success: function (data) {
				window.setRightSidebarContent(data || '<div class="alert alert-warning">Detail přílohy je prázdný.</div>');
				window.setRightSidebarTitle('Detail komponenty');
				window.showRightSidebar();
				epodatelnaSidebarOpen = true;
			},
			error: function (xhr) {
				const msg = (xhr && xhr.status)
					? ('Nepodařilo se načíst detail přílohy (HTTP ' + xhr.status + ').')
					: 'Nepodařilo se načíst detail přílohy.';
				window.setRightSidebarContent('<div class="alert alert-danger">' + msg + '</div>');
				window.setRightSidebarTitle('Detail komponenty');
				window.showRightSidebar();
				epodatelnaSidebarOpen = true;
			}
		});
	});
})();

